import React from 'react';

export type PageMaxWidth = 'narrow' | 'default' | 'wide' | 'full';

interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: PageMaxWidth;
  className?: string;
}

const widthClasses: Record<PageMaxWidth, string> = {
  narrow: 'max-w-2xl',    // 672px - 폼 페이지
  default: 'max-w-4xl',   // 896px - 일반 콘텐츠
  wide: 'max-w-6xl',      // 1152px - 테이블/리스트
  full: '',               // 전체 폭
};

/**
 * 공통 페이지 컨테이너
 * 모든 페이지는 이 컴포넌트로 감싸 일관된 레이아웃을 유지합니다.
 * 
 * @example
 * <PageContainer maxWidth="default">
 *   <PageHeader title="페이지 제목" description="설명" />
 *   <div>콘텐츠</div>
 * </PageContainer>
 */
export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = 'default',
  className = '',
}) => {
  const widthClass = widthClasses[maxWidth];
  
  return (
    <div className={`space-y-6 p-4 md:p-8 ${widthClass} ${className}`.trim()}>
      {children}
    </div>
  );
};
